//
import React, { useCallback, useEffect, useState } from "react";
import moment from "moment";
//component
import TriggerPlay from "./trigger/trigger_play";
import TriggerMonitor from "./trigger/trigger_monitor";
import TriggerChange from "./trigger/trigger_change";
import { GrRotateLeft, GrRotateRight } from "react-icons/gr";
import {
  Button,
  Col,
  Flex,
  Row,
  Select,
  Slider,
  Tooltip,
  Typography,
} from "antd";
import { CiPause1, CiPlay1, CiVolumeHigh, CiVolumeMute } from "react-icons/ci";
//redux
//selector
import {
  draftDialogDetailSelector,
  draftDialogIndexSelector,
  draftDialogPlaySelector,
  draftDialogSecondSelector,
} from "store/bailiff/task/dialog/draft_dialog.selector";
//actions
import { setDraftDialogPlay } from "store/bailiff/task/dialog/draft_dialog.action";
//utils
//hook
import { useSelector, useDispatch } from "react-redux";
import { useResponsive } from "hook/useResponsive";
//str

const AudioUrlClone = ({ url }) => {
  // -------------------------- VAR -----------------------------
  const { mobile } = useResponsive();
  const playSliderStyle = mobile ? { width: "90%" } : { width: "100%" };
  // -------------------------- STATE ---------------------------
  const [audio] = useState(new Audio(url));
  const [trigger, setTrigger] = useState(null);
  const [duration, setDuration] = useState(0);
  const [mute, setMute] = useState(false);
  const muteTitle = mute ? "Bật âm thanh" : "Tắt tiếng";
  const defaultAudioVolume = audio?.volume * 100;
  const currentTime = moment(audio?.currentTime * 1000).format("m:ss");
  const durationDisplay = moment(duration * 1000).format("m:ss") || "0:00";
  const items = [
    {
      key: "1",
      label: <Typography.Text>x0.50</Typography.Text>,
      value: 0.5,
    },
    {
      key: "2",
      label: <Typography.Text>x0.75</Typography.Text>,
      value: 0.75,
    },
    {
      key: "3",
      label: <Typography.Text>Thường</Typography.Text>,
      value: 1,
    },
    {
      key: "4",
      label: <Typography.Text>x1.50</Typography.Text>,
      value: 1.5,
    },
    {
      key: "5",
      label: <Typography.Text>x2.00</Typography.Text>,
      value: 2,
    },
  ];
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const detail = useSelector(draftDialogDetailSelector);
  const index = useSelector(draftDialogIndexSelector);
  const play = useSelector(draftDialogPlaySelector);
  const second = useSelector(draftDialogSecondSelector);
  const sentences = detail?.sentences || [];
  const exist = sentences[index] || null;
  const start = exist?.start;
  const end = exist?.end;
  const icon = !play ? <CiPlay1 /> : <CiPause1 />; //
  const title = !play ? "Phát" : "Dừng";
  const volIcon = mute ? <CiVolumeMute /> : <CiVolumeHigh />;
  // -------------------------- FUNCTION ------------------------
  const handleChange = (value) => {
    const id = `change-${moment()?.valueOf()}-${value}`;
    console.log({ id, second });
    setTrigger(id);
  };

  const togglePLay = useCallback(() => {
    dispatch(setDraftDialogPlay(!play));
  }, [dispatch, play]);

  const handleRewind = () => {
    let rewindSecond = second - 5;
    const valid = rewindSecond >= start;
    if (!valid) {
      rewindSecond = start;
    }
    const id = `change-${moment()?.valueOf()}-${rewindSecond}`;
    setTrigger(id);
  };

  const handleAdvance = () => {
    let advanceSecond = second + 5;
    const valid = advanceSecond <= end;
    if (!valid) {
      advanceSecond = end;
    }
    const id = `change-${moment()?.valueOf()}-${advanceSecond}`;
    setTrigger(id);
  };

  const handleChangeSpeed = (value) => {
    if (!audio) return;
    audio.playbackRate = value;
  };

  const handleVolume = (value) => {
    if (!audio) return;
    audio.volume = value / 100;
  };

  const toggleVol = () => {
    if (!audio) return;
    const newVolume = audio.volume === 0 ? 100 : 0;
    audio.volume = newVolume / 100;
    setMute(!mute);
  };
  // -------------------------- EFFECT --------------------------

  // nếu chạy lố thì sao.
  useEffect(() => {
    if (!audio) return;
    //nếu chưa tới start.
    if (second < start) {
      audio.pause();
      const id = `change-${moment()?.valueOf()}-${start}`;
      dispatch(setDraftDialogPlay(false));
      setTrigger(id);
    }

    //nếu quá end.
    if (second > end) {
      audio.pause();
      const id = `change-${moment()?.valueOf()}-${start}`;
      dispatch(setDraftDialogPlay(false));
      setTrigger(id);
    }
  }, [start, end, second, audio, dispatch]);

  useEffect(() => {
    if (!audio) return;
    audio.onloadedmetadata = (e) => setDuration(e.target.duration);

    return () => {
      // Pause the audio, remove its source to release resources.
      audio.pause();
      audio.removeAttribute("src");
      audio.load();
    };
  }, [audio]);
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderMobile = () => {
    return (
      <Row className="w-full">
        <Col span={24} align="center">
          {renderPlayRelated()}
        </Col>
        <Col span={24} className="flex items-center justify-center">
          {renderVolAndDur()}
          {renderRightAction()}
        </Col>
      </Row>
    );
  };

  const renderVolAndDur = () => {
    return (
      <>
        <Flex
          className="rounded-3xl hover:bg-gray-100 max-sm:w-24 md:w-7 md:overflow-hidden md:transition-all md:duration-300 md:hover:w-24"
          gap={mobile ? 0 : 3}
        >
          <Tooltip title={muteTitle}>
            <Button
              shape="circle"
              type="text"
              onClick={toggleVol}
              icon={<span className="anticon">{volIcon}</span>}
            />
          </Tooltip>
          <Slider
            disabled={mute}
            min={0}
            max={100}
            defaultValue={defaultAudioVolume}
            className="w-10"
            onChange={handleVolume}
          />
        </Flex>
        <Flex
          gap={4}
          className="cursor-default rounded-3xl px-2 hover:bg-gray-100"
          align="center"
        >
          {currentTime} / {durationDisplay}
        </Flex>
      </>
    );
  };

  const renderPlayRelated = () => {
    return (
      <>
        <Tooltip title={"Quay về 5s"}>
          <Button
            onClick={handleRewind}
            shape="circle"
            type="text"
            icon={
              <span className="anticon">
                <GrRotateLeft />
              </span>
            }
          />
        </Tooltip>
        <Tooltip title={title}>
          <Button
            onClick={togglePLay}
            shape="circle"
            type="text"
            icon={<span className="anticon">{icon}</span>}
          />
        </Tooltip>
        <Tooltip title={"Tới trước 5s"}>
          <Button
            onClick={handleAdvance}
            shape="circle"
            type="text"
            icon={
              <span className="anticon">
                <GrRotateRight />
              </span>
            }
          />
        </Tooltip>
      </>
    );
  };

  const renderLeftAction = () => {
    return (
      <Flex gap={10}>
        {renderPlayRelated()}
        {renderVolAndDur()}
      </Flex>
    );
  };

  const renderRightAction = () => {
    return (
      <Tooltip title={"Thay đổi tốc độ"}>
        <Select
          options={items}
          defaultValue={1}
          onChange={handleChangeSpeed}
          className="min-w-14 rounded-3xl border-0 px-2"
          styles={{ content: { minWidth: 48, justifyContent: "center" } }}
        />
      </Tooltip>
    );
  };

  const renderActions = () => {
    if (mobile) {
      return renderMobile();
    }
    return (
      <Flex justify="space-between" className="w-full">
        {renderLeftAction()}
        {renderRightAction()}
      </Flex>
    );
  };
  // -------------------------- MAIN ----------------------------
  return (
    <Flex
      style={{
        alignItems: "center",
        padding: 8,
        marginBottom: 20,
      }}
      vertical
    >
      <Slider
        value={second}
        min={start}
        max={end}
        step={0.01}
        tooltip={false}
        onChange={handleChange}
        style={playSliderStyle}
      />
      {renderActions()}
      <TriggerPlay audio={audio} />
      <TriggerMonitor audio={audio} />
      <TriggerChange trigger={trigger} audio={audio} />
    </Flex>
  );
};
export default AudioUrlClone;
